import user from '../../Basics/User'
const god = {
  templateName: 'cardTemplateVip09',
  imgSrc: 'card/template/vip01/cardTemplateVip09.png',
  desc: '静怡湖色',
  category: 'card',
  vipGrade: 1,
  attr: {
    textColor: {
      type: 'color',
      id: '',
      label: '文本颜色',
      value: '#fff'
    },
    bgImage: {
      type: 'image',
      id: '',
      label: '背景图片',
      value: 'card/material/landscape03.jpg'
    },
    modelSrc: {
      type: 'model',
      id: '',
      label: '上传模型',
      value: 'model/Lang.gltf'
    }
  }
}
god.attr = Object.assign(god.attr, user)
export default god
